import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import Dashboard from 'tailwind-components/Dashboard/Dashboard';
import SunshineDashboard from './SunshineDashboard';
import { getDashboardData } from 'state/actions/actions';

import { getCompany } from 'helpers/getCompanyVariables';

const isOneill = getCompany() === 'oneill';

function mapStateToProps({ user, dashboard, appointments }) {
  return {
    user: user.zohoData,
    carriers: appointments.appointedCarriers,
    requestedAppointments: appointments.requestedAppointments,
    actionableAppointments: appointments.actionableAppointments,
    announcements: dashboard.announcements,
    notes: dashboard.notes,
    importantDates: dashboard.importantDates,
    calendarEvents: dashboard.calendarEvents,
    owner: dashboard.owner
  };
}

export default connect(mapStateToProps, { getDashboardData })(
  withLocalLoader(
    isOneill ? Dashboard : SunshineDashboard,
    true,
    'Home',
    'Home',
    false,
    state => state.dashboard.loadingDashboard
  )
);
